module.exports = __webpack_public_path__ + "static/media/Tick-Box.1be2fe7a.svg";